import axios from 'axios'

const apiUrl: Record<string, string> = {
  'cms-dev.acto.net.br': 'https://cms-back-dev.acto.net.br/',
  localhost: 'https://cms-back-dev.acto.net.br/',
  'cms-qa.acto.net.br': 'https://cms-back-qa.acto.net.br/',
  'cms-demo.acto.net.br': 'https://cms-back-demo.acto.net.br/',
  'cms-osasco.acto.net.br': 'https://cms-back-osasco.acto.net.br/',
  'cms-santos.acto.net.br': 'https://cms-back-santos.acto.net.br/',
  'cms-mauaobras.acto.net.br': 'https://cms-back-maua.acto.net.br/',
  'cms-pauliniaobras.acto.net.br': 'https://cms-back-paulinia.acto.net.br/',
  'app-cms-front-paulinia-001.azurewebsites.net': 'https://cms-back-paulinia.acto.net.br/',
  'app-cms-front-manaus-001.azurewebsites.net': 'https://cms-back-manaus.acto.net.br/'
  }


const hostname = window.location.hostname

const baseURL = apiUrl[hostname] ?? apiUrl['cms-dev.acto.net.br']

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})
// Interceptor global de resposta para tratamento de erros estruturados
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.data) {
      // Backend retorna erro estruturado com formato: { status, error, message, path, timestamp, details? }
      const errorData = error.response.data;
      
      // Log estruturado para debug
      console.error('API Error:', {
        status: errorData.status || error.response.status,
        message: errorData.message || 'Erro desconhecido',
        path: errorData.path || error.config?.url,
        timestamp: errorData.timestamp || new Date().toISOString(),
        details: errorData.details
      });
      
      // Rejeita com o objeto de erro estruturado para ser tratado pelos componentes
      return Promise.reject(error);
    } else if (error.request) {
      // Requisição foi feita mas sem resposta
      console.error('Sem resposta do servidor:', error.request);
      return Promise.reject({
        response: {
          data: {
            status: 0,
            message: 'Sem resposta do servidor. Verifique sua conexão.',
            timestamp: new Date().toISOString()
          }
        }
      });
    } else {
      // Erro na configuração da requisição
      console.error('Erro ao configurar requisição:', error.message);
      return Promise.reject({
        response: {
          data: {
            status: 0,
            message: 'Erro ao fazer requisição: ' + error.message,
            timestamp: new Date().toISOString()
          }
        }
      });
    }
  }
)